export default __webpack_public_path__ + "static/avatar-kayi-special-1-detail-2c5f3adc265243aeab923fcbd72d3c71.png";